export const ApplicationTable = {
    PendingBuyRequest: 1,
    RequestHistory: 2,
}

export const UserCountPages = {
    SwarmBuyRequest: 0
}

export const BuyRequestStatus = {
    Accepted: 1,
    Rejected: 2,
    Lost: 3,
    Completed: 4, 
    Pending: 5,
    CanceledByBee: 6,
    OverTheLimit: 7
}

export const TransactionType = {
    Reward: 1,
    Penalty: 2,
    Deduction: 3,
    Bonus: 4,
    Royalty: 5
}

export const UserType = {
    Bee: 1,
    Contractor: 2,
    Employee: 3,
    NewBee: 4,
    HiveAdmin: 5
}

export const REWARD_OPTIONS = [
  { value: 0.25, label: "$0.25" },
  { value: 0.5, label: "$0.50" },
  { value: 1, label: "$1" },
  { value: 2, label: "$2" },
  { value: 3, label: "$3" },
  { value: 5, label: "$5" },
  { value: 7, label: "$7" },
  { value: 10, label: "$10" },
  { value: 15, label: "$15" },
  { value: 20, label: "$20" }
];